import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TESTIMONIALS_TOASTS = [
  { name: 'Marija P.', service: 'Natalnu Kartu', time: '5 min' },
  { name: 'Jovana S.', service: 'Godišnji Horoskop', time: '12 min' },
  { name: 'Stefan M.', service: 'Tranzitnu Analizu', time: '8 min' },
  { name: 'Ana K.', service: 'Solarnu Kartu', time: '15 min' },
  { name: 'Nikola D.', service: 'Natalnu Kartu', time: '3 min' },
];

export function SocialProofToasts() {
  const [currentToast, setCurrentToast] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const showToast = () => {
      setShow(true);
      setTimeout(() => {
        setShow(false);
      }, 4000);
    };

    // Prvi toast nakon 5 sekundi
    const initialTimer = setTimeout(showToast, 5000);

    // Sledeći toasti svakih 15 sekundi
    const interval = setInterval(() => {
      setCurrentToast((prev) => (prev + 1) % TESTIMONIALS_TOASTS.length);
      showToast();
    }, 15000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);

  const toast = TESTIMONIALS_TOASTS[currentToast];

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ x: -400, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -400, opacity: 0 }}
          className="fixed bottom-24 left-4 z-40 bg-white dark:bg-gray-800 rounded-lg shadow-2xl p-4 max-w-sm border-l-4 border-green-500"
        >
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center">
              <span className="text-green-600 dark:text-green-400 text-xl">✓</span>
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-gray-900 dark:text-white">
                {toast.name} upravo naručila {toast.service}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Pre {toast.time}
              </p>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
